import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { StoreModule } from "@ngrx/store";

import { FuseSharedModule } from "@fuse/shared.module";

import { FooterComponent } from "app/layout/components/footer/footer.component";
import {
    DOCUMENTATION,
    documentationReducer,
} from "app/main/documentation/documentation.state";
import { EffectsModule } from "@ngrx/effects";
import { NgrxAutoEntityModule } from "@briebug/ngrx-auto-entity";
import { DocumentationEffects } from "app/main/documentation/documentation.effects";
import { Documentation } from "app/main/documentation/documentation.model";
import { DocumentationService } from "app/main/documentation/documentation.service";
import { DocumentationFacade } from "app/main/documentation/documentation.facade";
import { SousDocumentation } from "app/main/sousdocumentation/sousdocumentation.model";
import { SousDocumentationService } from "app/main/sousdocumentation/sousdocumentation.service";
import { SousDocumentationFacade } from "app/main/sousdocumentation/sousdocumentation.facade";
import { SOUSDOCUMENTATION, sousdocumentationReducer } from "app/main/sousdocumentation/sousdocumentation.state";
import { SousDocumentationEffects } from "app/main/sousdocumentation/sousdocumentation.effects";
import { MatMenuModule } from "@angular/material/menu";
import { DialogModule } from "primeng/dialog";

@NgModule({
    declarations: [FooterComponent],
    imports: [
        RouterModule,

        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatMenuModule,
        DialogModule, // Add DialogModule here

        FuseSharedModule,

        StoreModule.forFeature(DOCUMENTATION, documentationReducer),
        StoreModule.forFeature(SOUSDOCUMENTATION, sousdocumentationReducer),

        EffectsModule.forFeature([DocumentationEffects,SousDocumentationEffects]),

        NgrxAutoEntityModule.forFeature(),
    ],
    providers: [
        { provide: Documentation, useClass: DocumentationService },
        DocumentationService,
        DocumentationFacade,

        { provide: SousDocumentation, useClass: SousDocumentationService },
        SousDocumentationService,
        SousDocumentationFacade,
        
    ],
    exports: [FooterComponent],
})
export class FooterModule {}
